import { render, staticRenderFns } from "./CMAccountMembersGroupList.vue?vue&type=template&id=53022bf2&"
import script from "./CMAccountMembersGroupList.vue?vue&type=script&lang=js&"
export * from "./CMAccountMembersGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53022bf2')) {
      api.createRecord('53022bf2', component.options)
    } else {
      api.reload('53022bf2', component.options)
    }
    module.hot.accept("./CMAccountMembersGroupList.vue?vue&type=template&id=53022bf2&", function () {
      api.rerender('53022bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMAccountMembersPage/CMAccountMembersGroupList.vue"
export default component.exports